import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div
        data-testid="payment-cancel"
        className="max-w-md w-full bg-white rounded-[1.75rem] border border-[var(--oz-border)] p-8 md:p-10 text-center shadow-[0_30px_60px_-30px_rgba(26,23,20,0.4)]"
      >
        <XCircle className="w-14 h-14 mx-auto text-[var(--oz-muted)]" />
        <h1 className="font-serif text-3xl mt-6 text-[var(--oz-text)]">Paiement annulé</h1>
        <p className="mt-3 text-sm text-[var(--oz-muted)] leading-relaxed">
          Votre paiement a été annulé et aucun montant n'a été prélevé. Votre panier est conservé,
          vous pouvez reprendre votre commande quand vous le souhaitez.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="mt-7 inline-block px-6 py-3.5 rounded-full bg-[var(--oz-dark)] text-white font-semibold text-sm hover:bg-black transition-colors"
        >
          Retour aux packs
        </Link>
      </div>
    </div>
  );
}
